// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".footer-value-info p[data-v-6af8f39d] {\n  line-height: 25px;\n}", ""]);
// Exports
module.exports = exports;
